import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface FeedbackRow {
  id: string;
  user_id: string;
  rating: number | null;
  transcript: string | null;
  audio_path: string | null;
  image_path: string | null;
  duration_seconds: number | null;
  locale: string;
  app_version: string | null;
  created_at: string;
}

export function useFeedbackList() {
  const query = useQuery({
    queryKey: ["user-feedback"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_feedback")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(500);
      if (error) throw error;
      return (data as FeedbackRow[]) ?? [];
    },
  });

  return {
    data: query.data,
    rows: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
